import { useEffect } from 'react'
import L from 'leaflet'
import 'leaflet-control-geocoder'
import 'leaflet-control-geocoder/dist/Control.Geocoder.css'
import { withLeaflet } from 'react-leaflet'

function LeafletControlGeocoder({ setPolygonData, setAddress, leaflet }) {
  const map = leaflet.map

  useEffect(() => {
    var geocoder = L.Control.Geocoder.nominatim({
      geocodingQueryParams: { limit: 4, countrycodes: 'pt' },
    })
    // if (typeof URLSearchParams !== 'undefined' && location?.search) {
    //   // parse /?geocoder=nominatim from URL
    //   var params = new URLSearchParams(location?.search)
    //   var geocoderString = params.get('geocoder')
    //   if (geocoderString && L.Control.Geocoder[geocoderString]) {
    //     geocoder = L.Control.Geocoder[geocoderString]()
    //   } else if (geocoderString) {
    //     console.warn('Unsupported geocoder', geocoderString)
    //   }
    // }

    L.Control.geocoder({
      query: '',
      placeholder: 'Pesquise Aqui...',
      defaultMarkGeocode: false, // Disable automatic marker creation
      geocoder,
    })
      .on('markgeocode', function (e) {
        var latlng = e.geocode.center
        if (typeof setPolygonData === 'function') {
          setPolygonData([latlng.lat, latlng.lng])
        }
        const address = e.geocode?.properties?.address
        if (typeof setAddress === 'function') {
          setAddress({
            local: address?.hamlet || address?.neighbourhood,
            address: address.road,
            freguesia:
              address?.cityDistrict || address?.village || address?.town,
          })
        }
        // Prevent default marker and popup behavior
        // We'll handle this with our own draggable marker
      })
      .addTo(map)
  }, [map])

  return null
}

export default withLeaflet(LeafletControlGeocoder)
